import { Address } from "projects/erp-app/src/app/base/addresses/addresses/address.model";
import { Third } from "../../third.model";
import { ThirdAddressType } from "../third-address-types/third-address-type.model";


export class ThirdAddress extends Address {
    public ThirdId: Third = new Third();
    public override AddressTypeId: ThirdAddressType = new ThirdAddressType();
}
